export const getDefaultState = () => {
  return {
    enrichedLead: {},
    user: {},
    partner: {},
    vendor: {},
    linkedinAccountStatus: {},
    connectors: [],
    notificationSettings: [],
    isAdmin: false,
    isImpersonating: false,
    // TODO: these fields are just here temporarily until we move /users to a version 2 endpoint
    // and fix the shape of the data
    mediumDrawerOpen: false,
    partnerId: null,
    vendorId: null,
    isSignatureLoading: false,
    userNylasSignature: null,
    vendorCustomTableFields: [],
  }
}
